// API Configuration
// This file centralizes API endpoint configuration.
// Set REACT_APP_API_BASE_URL in development when the backend is not localhost:4000.

const trimTrailingSlash = (value = "") => String(value || "").replace(/\/+$/, "");

const configuredApiBase = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE);

const getApiBase = () => {
  if (configuredApiBase) {
    return configuredApiBase;
  }

  // In production, use relative URLs or the actual domain
  if (process.env.NODE_ENV === 'production') {
    // Use relative URL in production (same domain)
    return '/api';
  }
  // Development: use localhost
  return 'http://localhost:4000/api';
};

export const API_BASE = getApiBase();
export const API_BASE_FULL = API_BASE.startsWith('http')
  ? API_BASE
  : `${window.location.origin}${API_BASE}`;

// Backend base URL (without /api)
export const BACKEND_BASE = trimTrailingSlash(API_BASE_FULL.replace(/\/api$/, ''));
